<div class="no-results-splash" *ngIf="show">
  No results for “{{searchValue}}”
  <ul>
    <li>Check for typos and spelling errors</li>
    <li>Try more general keywords</li>
    <li>Try different keywords</li>
  </ul>
</div>
